'use client'

import { Badge } from '@/components/v2/ui/badge'
import { useTexts } from '@/contexts/LanguageContext'

export default function CertificationBadge() {
  const { STATUS } = useTexts().PUBLIC_TRUST_CENTER.CERTIFICATIONS
  return (
    <Badge
      variant="outline"
      className="shrink-0 rounded-full border-trust-center-border-strong bg-trust-center-border text-trust-center"
    >
      {STATUS.CERTIFIED}
    </Badge>
  )
}
